import React from 'react';
import { Table } from 'react-bootstrap';

import styles from './NormsTable.module.scss';

const NormsTable = () => (
  <Table style={{ fontSize: '0.9rem' }} className={styles.norms_table} striped bordered responsive>
    <tbody>
      <tr>
        <td colSpan={2}>&nbsp;</td>
        <td>Норма</td>
        <td>Превышение нормы</td>
        <td>Значительное превышение нормы</td>
      </tr>

      <tr>
        <td rowSpan={8} style={{ writingMode: 'vertical-lr', transform: 'rotate(180deg)' }}>ИРП</td>
        <td colSpan={4}>Девушки</td>
      </tr>

      <tr>
        <td>Форма A</td>
        <td>1-43%</td>
        <td>44-50%</td>
        <td>51-100%</td>
      </tr>

      <tr>
        <td>Форма B</td>
        <td>1-41%</td>
        <td>42-46%</td>
        <td>47-100%</td>
      </tr>

      <tr>
        <td>Форма C</td>
        <td>1-42%</td>
        <td>43-51%</td>
        <td>52-100%</td>
      </tr>

      <tr>
        <td colSpan={4}>Юноши</td>
      </tr>

      <tr>
        <td>Форма A</td>
        <td>1-43%</td>
        <td>44-50%</td>
        <td>51-100%</td>
      </tr>

      <tr>
        <td>Форма B</td>
        <td>1-40%</td>
        <td>41-47%</td>
        <td>48-100%</td>
      </tr>

      <tr>
        <td>Форма C</td>
        <td>1-40%</td>
        <td>41-50%</td>
        <td>51-100%</td>
      </tr>

      <tr>
        <td rowSpan={8} style={{ writingMode: 'vertical-lr', transform: 'rotate(180deg)' }}>КВЕРИПО</td>
        <td colSpan={4}>Девушки</td>
      </tr>

      <tr>
        <td>Форма A</td>
        <td>&#8804; 0,78</td>
        <td colSpan={2}>&gt; 0,78</td>
      </tr>

      <tr>
        <td>Форма B</td>
        <td>&#8804; 0,72</td>
        <td colSpan={2}>&gt; 0,72</td>
      </tr>

      <tr>
        <td>Форма C</td>
        <td>&#8804; 0,75</td>
        <td colSpan={2}>&gt; 0,75</td>
      </tr>

      <tr>
        <td colSpan={4}>Юноши</td>
      </tr>

      <tr>
        <td>Форма A</td>
        <td>&#8804; 0,78</td>
        <td colSpan={2}>&gt; 0,78</td>
      </tr>

      <tr>
        <td>Форма B</td>
        <td>&#8804; 0,70</td>
        <td colSpan={2}>&gt; 0,70</td>
      </tr>

      <tr>
        <td>Форма C</td>
        <td>&#8804; 0,97</td>
        <td colSpan={2}>&gt; 0,97</td>
      </tr>
    </tbody>
  </Table>
);

export default NormsTable;
